export function formdataFromObj(obj: Record<string, any>): FormData {
  const formData = new FormData();

  for (const key in obj) {
    if (obj[key] instanceof Array) {
      obj[key].forEach((item: any, i) => {
        formData.append(`${key}[${i}]`, item);
      });
    } else {
      formData.append(key, obj[key]);
    }
  }

  return formData;
}
